export default __webpack_public_path__ + "static/media/Deed of Contract - Img - Final (2)_07.d7789743.jpg";